import React from 'react'; 
import '../../css/Shared//Footer2.css';

function Footer2() {
  return (
   <footer class="page-footer font-small fixed-bottom" id='footer'>
     <div class="footer-copyright text-center pb-3" > 
      <p id="footerContent" style={{marginTop:22, marginBottom:10}}>© Copyright Transnet 2021. All Rights Reserved.</p>
     </div>
     {/* <small  id="FooterReleaseText">Test-2</small> */}
   </footer>
  );
}
export default Footer2;